import { useAiSettings } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

/**
 * Whether the Form Authoring Coach is available: the employee's coaching FF, the company's
 * form-authoring-coach rollout FF, and the company's Form Authoring Coach setting.
 */
export const useFormAuthoringCoachEnabled = (): boolean => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: coachingEnabled } = useFeatureFlagQuery("ff-is-coaching-enabled", false);
	const { value: formAuthoringCoachFeatureEnabled } = useFeatureFlagQuery(
		"ff-temp-is-form-authoring-coach-enabled",
		false
	);

	const { data: aiSettings } = useAiSettings();
	const formAuthoringCoachEnabled = aiSettings?.formAuthoringCoachEnabled ?? false;

	return aiEnabled && coachingEnabled && formAuthoringCoachFeatureEnabled && formAuthoringCoachEnabled;
};
